import { useCallback, useEffect, useState } from "react";
import { findList } from "../../../../../api/ContactAPI";
import { LoadingOverlay, Stack, Text } from "@mantine/core";
import ListsContent from "./ListsContent";
import { useParams } from "react-router-dom";
import ListsContentAll from "./ListsContentAll";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useListStore } from "../../../../../stores/ListStore";

const RightWrapperContacts = ({ isMinimized }) => {
  const lang = useLanguage((s) => s.language);
  const { contactListId, folderId } = useParams();
  const [loading, setLoading] = useState(false);
  const list = useListStore((s) => s.currentList);
  const setList = useListStore((s) => s.setCurrentList);

  const handleLoading = useCallback(() => {
    if (loading) {
      return;
    }
    setLoading(true);

    findList(contactListId)
      .then((res) => {
        setList(res.data.contact_list_profile);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [contactListId]);

  useEffect(() => {
    if (contactListId !== "none" && contactListId !== "all") {
      handleLoading();
    }
  }, [contactListId]);

  if (contactListId === "none") {
    if (folderId) {
      if (folderId === "none") {
        return (
          <Stack h={"100%"} flex={1} align="center" justify="center">
            <Text>{lang.prospects.select_folder}</Text>
          </Stack>
        );
      } else {
        return (
          <Stack h={"100%"} flex={1} align="center" justify="center">
            <Text>{lang.prospects.select_list}</Text>
          </Stack>
        );
      }
    }
    return (
      <Stack h={"100%"} flex={1} align="center" justify="center">
        <Text>{lang.prospects.select_list}</Text>
      </Stack>
    );
  }

  return (
    <Stack h={"100%"} pos={"relative"} flex={1}>
      {loading ? (
        <LoadingOverlay visible loaderProps={{ size: 48 }} />
      ) : contactListId === "all" ? (
        <ListsContentAll isMinimized={isMinimized} />
      ) : (
        <ListsContent isMinimized={isMinimized} list={list} />
      )}
    </Stack>
  );
};

export default RightWrapperContacts;
